import MyCollection from './MyCollection';
import UpperGreenpillSection from './UpperGreenpillSection';

const GreenpillHomePage = () => {
    return (
        <div className="">
            <div className={` w-full`}>
                <div className="   h-full  main overflow-auto">
                    <UpperGreenpillSection />
                </div>
                <MyCollection />
            </div>
        </div>
    );
};

export default GreenpillHomePage;
